var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnsatRatingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.186816 14.0589C1.34615 20.5751 7.54257 24.9326 14.0988 23.7733C20.615 22.6139 24.9725 16.4175 23.8132 9.86129C22.6539 3.38502 16.4174 -0.972464 9.90121 0.186867C3.38497 1.30622 -0.972515 7.54262 0.186816 14.0589Z",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1391 11.0608C17.243 11.0608 18.138 10.1659 18.138 9.06194C18.138 7.95801 17.243 7.0631 16.1391 7.0631C15.0352 7.0631 14.1403 7.95801 14.1403 9.06194C14.1403 10.1659 15.0352 11.0608 16.1391 11.0608Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06409 12.6598C8.16803 12.6598 9.06294 11.7649 9.06294 10.661C9.06294 9.55704 8.16803 8.66212 7.06409 8.66212C5.96016 8.66212 5.06525 9.55704 5.06525 10.661C5.06525 11.7649 5.96016 12.6598 7.06409 12.6598Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4982 15.8978C14.1795 15.2981 11.701 15.7379 9.74209 17.0971C9.26237 17.4569 10.1818 18.6962 10.6616 18.3763C11.9408 17.4569 14.0196 16.8572 16.1384 17.4169C16.6581 17.5368 17.0978 16.0977 16.4982 15.8978Z",
    fill: "#664E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsatRatingIcon);
export default __webpack_public_path__ + "static/media/unsat-rating-icon.d484fe7387f60bac6a2bb7682f6c323d.svg";
export { ForwardRef as ReactComponent };